import moment from "moment";
import { setChatCount, setChatState } from "../redux/actions/actions";
import { Postrequestcall } from "../request/Postrequest";
import { FETCH_CHAT_GROUP_DASHBOARD, SAVE_CHAT_GROUP_USERS } from "../constant/Apipath";

import avtar_placeholder from "../assets/images/avtar_placeholder.jpeg";

export const getMyDate = (date) => {
  if (!moment.isMoment(date)) date = moment(date);
  if (date.isSame(moment(), "day")) {
    return "Today";
  } else if (date.isSame(moment().subtract(1, "d"), "day")) {
    return "Yesterday";
  } else {
    return moment.parseZone(date).local().format("MMM DD");
  }
};

export const getCurrentChatgroup = async (chatGroupId, loginData) => {
  try {
    const obj = {
      UserId: loginData?.userInformation?.UserId,
      ChatGroupId: chatGroupId
    };
    const getChatgroupDashboard = await Postrequestcall(
      FETCH_CHAT_GROUP_DASHBOARD,
      obj,
      loginData?.accessToken
    );

    if (getChatgroupDashboard.status === 200) {
      if (getChatgroupDashboard?.data?.data?.length > 0) {
        const chatGroupData = getChatgroupDashboard?.data?.data[0];
        return getChatgroupdata(chatGroupData, loginData);
      }
    }
    return null;
  } catch (error) {
    console.error("❌ Error getting current chat group:", error);
    return null;
  }
};

export const getChatgroups = async (dispatch, loginData) => {
  try {
    const obj = {
      UserId: loginData?.userInformation?.UserId,
      ChatGroupId: 0
    };
    const getChatgroupDashboard = await Postrequestcall(
      FETCH_CHAT_GROUP_DASHBOARD,
      obj,
      loginData?.accessToken
    );
    if (getChatgroupDashboard.status === 200) {
      const filterData = getChatgroupDashboard?.data?.data
        ?.filter((chat) => {
          if (chat?.messageText?.length > 0) {
            return chat;
          }
          return true;
        })
        ?.sort((a, b) => {
          let dateA = new Date(a.dateSent),
            dateB = new Date(b.dateSent);
          return dateB - dateA;
        });
      const getChatgroups = filterData.map((chatItem) => {
        return getChatgroupdata(chatItem, loginData);
      });
      const totalUnreadMessages = getChatgroups.reduce((total, chatItem) => {
        return total + (chatItem?.unreadMessagesNr || 0);
      }, 0);
      dispatch(setChatCount(totalUnreadMessages));
      return getChatgroups;
    }
  } catch (error) { }
};

const getChatgroupdata = (chatItem, loginData) => {
  let grpName = "";
  if (chatItem?.groupUserFirstName1?.trim()?.length > 0) {
    grpName = chatItem.groupUserFirstName1.trim();
  }
  if (chatItem?.nrOfUsersInGroup <= 2) {
    grpName = grpName + " " + (chatItem.groupUserLastName1?.trim() || "");
  }
  if (
    chatItem?.fromUserId === loginData?.userInformation?.UserId &&
    chatItem?.nrOfUsersInGroup == 1
  ) {
    grpName = grpName + " (me)";
  }
  if (chatItem?.nrOfUsersInGroup === 3) {
    if (chatItem?.groupUserFirstName2?.trim()?.length > 0) {
      grpName = grpName + ` and ${chatItem?.groupUserFirstName2?.trim()}`;
    }
  }
  if (chatItem?.nrOfUsersInGroup > 3) {
    if (chatItem?.groupUserFirstName2?.trim()?.length > 0) {
      grpName =
        grpName +
        `, ${chatItem?.groupUserFirstName2?.trim()} and ${chatItem?.nrOfUsersInGroup - 3} others`;
    } else {
      grpName = grpName + `, and ${chatItem?.nrOfUsersInGroup - 3} others`;
    }
  }
  grpName = grpName.trim();
  if (chatItem?.appRecordName) {
    grpName = chatItem?.appRecordName || "Unknown Group";
  }
  if (grpName.length > 70) {
    grpName = grpName.substring(0, 70) + "...";
  }
  return {
    ...chatItem,
    name: grpName,
    isGroupchat: chatItem?.nrOfUsersInGroup > 2 ? true : false,
    groupUserPictureUrl1: getPictureUrl(chatItem?.groupUserPictureUrl1),
    groupUserPictureUrl2: getPictureUrl(chatItem?.groupUserPictureUrl2),
    pictureUrl:
      chatItem?.nrOfUsersInGroup == 1 && chatItem?.fromUserId === loginData?.userInformation?.UserId
        ? getPictureUrl(loginData?.pictureUrl)
        : getPictureUrl(chatItem?.groupUserPictureUrl1),
    messageText:
      chatItem?.messageTypeId === 6 ? chatItem?.messageText : getLastMessage(chatItem, loginData),
    dateSent: chatItem?.dateSent, // Keep original ISO date for sorting
    dateSentDisplay: getFormattedDate(chatItem?.dateSent) // Formatted for display
  };
};

export const getLastMessage = (chatItem, loginData) => {
  const isImage = chatItem?.messageText?.match(/^http.*\.(jpeg|jpg|gif|png)$/) != null;
  let message = "";
  if (chatItem?.messageText?.length > 0) {
    if (chatItem?.fromUserId === loginData?.userInformation?.UserId) {
      message = "You:";
    } else {
      message = chatItem?.fromUserFirstName
        ? (chatItem?.fromUserFirstName?.trim() || "") + ":"
        : (chatItem?.fromFirstName?.trim() || "") + ":";
    }
    if (isImage) {
      message += " Photo";
    } else {
      message += " " + chatItem?.messageText.trim();
    }
  }
  if (message.length > 60) {
    message = message.substring(0, 60) + "...";
  }
  return message;
};

export const getPictureUrl = (url) => {
  return url && url.trim() !== "" ? url : avtar_placeholder;
};

export const getFormattedDate = (date) => {
  if (!date) return "";
  if (!moment.isMoment(date)) date = moment(date);
  if (!date.isValid()) return "";
  if (date.isSame(moment(), "day")) {
    return moment.parseZone(date).local().format("h:mm a");
  } else if (date.isSame(moment().subtract(1, "d"), "day")) {
    return "Yesterday";
  } else if (date.isSame(moment(), "week")) {
    return moment.parseZone(date).local().format("dddd");
  } else {
    return moment.parseZone(date).local().format("YYYY-MM-DD");
  }
};

export const navigateToChatPage = (
  navigate,
  dispatch,
  from,
  title,
  imageUrl,
  chatGroupId,
  getUrl
) => {
  const chatState = {
    from,
    chatGroupId,
    refresh: true,
    ...(from !== "notification" && {
      messageLink: `${import.meta.env.REACT_APP_BASE_URL}${from.toLowerCase()}/${getUrl}&name=${title}&id=${getUrl}&type=${from.toLowerCase()}&picture=${imageUrl || ""}`,
      messageText: {
        type: from,
        name: title,
        id: getUrl,
        imageUrl: imageUrl
      }
    })
  };
  dispatch(setChatState(chatState));
  navigate("/chat");
};

export const createChatGroupAndNavigate = async (userId, loginData, dispatch, navigate, from) => {
  try {
    const chatGroupObj = {
      UserId: Number(loginData?.userInformation?.UserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          Id: 0,
          ChatGroupId: 0,
          UserId: Number(userId),
          ModifiedBy: Number(loginData?.userInformation?.UserId),
          Muted: false
        }
      ]
    };
    const result = await Postrequestcall(
      SAVE_CHAT_GROUP_USERS,
      chatGroupObj,
      loginData?.accessToken
    );
    if (result.status === 201) {
      let getChatgroupId = result.data.data[0]?.objData?.chatGroupId;
      const chatState = {
        chatGroupId: getChatgroupId,
        from: from,
        refresh: new Date().getTime()
      };
      dispatch(setChatState(chatState));
      navigate("/chat");
    }
  } catch (error) {
    console.error(
      "createChatGroupAndNavigate-> Error While Creating/Navigating Chat Group: ",
      error
    );
  }
};

export const navigateToClientChatPage = (navigate, clientId, chatGroupId) => {
  navigate(`/client/${clientId}/chat`, {
    state: {
      from: "notification",
      chatGroupId: chatGroupId
    }
  });
};
